export class UseCase {
  static create() {
    throw new Error('[UseCase.create] should be implemented');
  }

  execute() {
    throw new Error('[UseCase#execute] should be implemented');
  }

}
export class Service {
  static create() {
    throw new Error('[Service.create] should be implemented');
  }

  execute() {
    throw new Error('[Service#execute] should be implemented');
  }

}
export class Repository {
  static create() {
    throw new Error('[Repository.create] should be implemented');
  }

}
export class Request {
  static create() {
    throw new Error('[Request.create] should be implemented');
  }

}
export class Model {
  static create() {
    throw new Error('[Model.create] should be implemented');
  }

  toJSON() {
    throw new Error('[Model#toJSON] should be implemented');
  }

  hasRelationship(relation) {
    var _this$_relationships, _this$_relationships$;

    const data = (_this$_relationships = this._relationships) == null ? void 0 : (_this$_relationships$ = _this$_relationships[relation]) == null ? void 0 : _this$_relationships$.data;
    return Boolean(data && (Array.isArray(data) || Object.prototype.toString.apply(data) === '[object Object]'));
  }

  relationshipIDs(relation) {
    var _this$_relationships2, _this$_relationships3;

    const data = (_this$_relationships2 = this._relationships) == null ? void 0 : (_this$_relationships3 = _this$_relationships2[relation]) == null ? void 0 : _this$_relationships3.data;

    if (Array.isArray(data) && data.length > 0) {
      return data.map(entry => entry.id);
    }

    if (data != null && data.id) {
      return [data.id];
    }

    return [];
  }

}
export class Mapper {
  static create() {
    throw new Error('[Mapper.create] should be implemented');
  }

  map() {
    throw new Error('[Mapper#map] should be implemented');
  }

}
export class DataSource {
  data() {
    throw new Error('[DataSource#data] should be implemented');
  }

}
export class DomainError extends Error {}